export default {
  path: '/data-imports',
  component: () => import(/* webpackChunkName: "data-imports" */ './DataImports'),
  meta: {
    requiresAuth: true,
    requiresDataImportsAccess: true
  }
}
